import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { T } from '../../utils/adminTheme';

interface ModalWrapperProps {
  onClose: () => void;
  maxWidth?: number;
  children: React.ReactNode;
}

const ModalWrapper: React.FC<ModalWrapperProps> = ({ onClose, maxWidth = 480, children }) => {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.55)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 50,
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: T.surface,
          borderRadius: T.r.lg,
          border: `1px solid ${T.line}`,
          boxShadow: '0 24px 64px rgba(0,0,0,0.18)',
          width: '100%',
          maxWidth,
          maxHeight: '90vh',
          overflowY: 'auto',
          position: 'relative',
        }}
      >
        <button
          onClick={onClose}
          aria-label="Schließen"
          style={{
            position: 'absolute',
            top: 14,
            right: 14,
            zIndex: 10,
            width: 30,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: T.surface2,
            border: `1px solid ${T.line}`,
            borderRadius: '50%',
            cursor: 'pointer',
            color: T.muted,
          }}
        >
          <X size={15} />
        </button>

        <div style={{ padding: '28px 28px 24px' }}>{children}</div>
      </div>
    </div>
  );
};

export default ModalWrapper;
